export const VERSION = '3.9.0';
export const GIT_HASH = '21add2dcffadd3c69673e29e7e27d80c1f8b9a1a';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'bowl';
